var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "control-label-vertical",
      attrs: { column: "", wrap: "", "py-0": "" }
    },
    [
      _vm.label
        ? _c("v-subheader", { staticClass: "control-label-vertical__label" }, [
            _c(
              "strong",
              {
                staticClass: "text-lg-left mt-0",
                class: _vm.isRequired
                  ? "label-required--has-required"
                  : "label-required--norequired"
              },
              [_vm._v(_vm._s(_vm.$t(_vm.label)))]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "px-3 mt-2", staticStyle: { position: "relative" } },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.showError
            ? _c(
                "div",
                {
                  staticClass: "v-messages v-messages__message error--text",
                  staticStyle: { position: "absolute", bottom: "0" }
                },
                [_vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fd478be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fd478be","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/control-label-vertical/template.html
// module id = null
// module chunks = 